export default __webpack_public_path__ + "static/media/warning--emu-crossing--g2.fee7dc08.png";